import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/Home.vue'
import TalentTest from '../components/TalentTest.vue'
import TestResult from '../components/TestResult.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/test',
    name: 'TalentTest',
    component: TalentTest
  },
  {
    path: '/result',
    name: 'TestResult',
    component: TestResult
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

